import { render } from "./UploadLibroMayor.vue?vue&type=template&id=33f76826"
import script from "./UploadLibroMayor.vue?vue&type=script&lang=js"
export * from "./UploadLibroMayor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__